export const buildCanonicalPath = (path: string) => {
    const canonicalPath = path.replace(/^\/|\/$/g, '');

    if (canonicalPath === '') {
        return canonicalPath;
    }

    return path.includes('pn=') ? canonicalPath : `${canonicalPath}/`;
};
